export default function IconMinus(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" {...props}>
    <path d="M432 272H416L32 272H16l0-32 16 0 384 0 16 0v32z"/>
  </svg>;
}